/* eslint-disable no-unused-vars */
import ApiService from "../../api.service";
import appConfig from "../../../../app-config";
import { TokenStorage } from "../../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ForeignCurrencyService = {
  /**
   * Get currency By Code
   *
   * */
  async getByCode(currencycode) {
    const requestScreenData = {
      url: "api/CompanyCurrency",
      top: "1",
      filter: `CurrencyCode eq '${currencycode}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getDefaultCurrecy(params) {
    const requestScreenData = {
      url: "api/CompanyCurrency",
      top: "1",
      filter: `IsDefault eq 'Y' and Inactive eq 'N'`,
    };
    if(params){
      if(params.select) requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async save(mode, ForeignCurrency) {
    var payload = ForeignCurrency;
    var url = "api/CompanyCurrency";

    if (mode == "create") {
      return await ApiService.post(url, payload, "String");
    } else {
      return await ApiService.patch(
        url,
        ForeignCurrency.CurrencyCode,
        payload,
        "String"
      );
    }
  },

  async markAsDefault(payload) {
    let url = "api/Save_DefaultCompanyCurrency";
    return await ApiService.post(url, payload);
  },

  async getItems(requestParams) {
    return await ApiService.oDataGet(requestParams);
  },
};

export { ForeignCurrencyService };
